export function getdata() {
	var obj = {
		headlist: [{
				name: "文件上传"
			},
			{
				name: "凭证明细"
			},
			{
				name: "上传结果"
			}
		]
	}
	return obj
}
